import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { object, string } from "yup"

const schema = object({
  message: string()
    .required()
    .transform((value) => (/.*\S.*/.test(value) ? value : null))
    .typeError("Message can't be embty!"),
}).required()

export default function useNewMessageForm(defaultValues?: { message: string }) {
  return useForm<{ message: string }>({
    resolver: yupResolver(schema),
    defaultValues,
  })
}
